import sanitizeSecret from './sanitizeSecret';

// report an error to bugsnag, optionally with some additional context.
// should be *called* where you want to capture stack trace.
export default function notifyError(
  originalErr?: Error,
  context?: Record<string, unknown>,
  groupingHash?: string | Record<string, unknown>
) {
  if (!originalErr) return;
  // avoid logging when pages have been saved and viewed on a local machine
  if (window.location.protocol === 'file:') {
    return;
  }

  // a new Error is created to capture current stack
  // see 'previousStack' for original error location
  const err = new Error(originalErr.message);
  // copy over custom name eg. RequestError
  err.name = originalErr.name;

  // convenience for development
  if (window.console) {
    window.console.error('Unhandled Error:', err, 'Caused by:', originalErr);
  }

  window.bugsnagClient.notify(err, {
    groupingHash,
    metaData: {
      errorContext: {
        ...sanitizeSecret(context),
        previousStack: originalErr.stack, // 'previousStack' should appear in Bugsnag 'error context' tab
      },
    },
  });
}
